import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '@/hooks/useApiMutation';
import { apiPatch, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { EstimateSettings } from '@/types/settings';

export function useSaveEstimateSettings() {
  const queryClient = useQueryClient();

  return useApiMutation<EstimateSettings, Partial<EstimateSettings>>({
    mutationFn: (dto) =>
      apiPatch<EstimateSettings, Partial<EstimateSettings>>(
        operationsClient,
        settingsEndpoints.estimateSettings(),
        dto,
      ),
    onSuccess: (data) => {
      queryClient.setQueryData(settingsKeys.estimateSettings(), data);
      toast.success('Estimate settings saved');
    },
  });
}
